import {
  bscTestnet,
  sepolia,
  mainnet,
  polygon,
  bsc,
  base,
  arbitrum,
  avalanche,
  linea,
  opBNB,
} from "viem/chains";
import { createPublicClient, http } from "viem";
import type { PrivyClientConfig } from "@privy-io/react-auth";
import { PrivyProvider } from "@privy-io/react-auth";
import { WagmiProvider, createConfig } from "@privy-io/wagmi";
import Config from "@/config";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import config from "@/config";

export const publicClient = createPublicClient({
  chain: bscTestnet,
  transport: http(),
});

const TEST_LINK = {
  testLink2: config.CONTRACT.TEST_LINK_2,
  testLink1: config.CONTRACT.TEST_LINK_1,
  testLink3: config.CONTRACT.TEST_LINK_3,
  testLink4: config.CONTRACT.TEST_LINK_4,
  testLink5: config.CONTRACT.TEST_LINK_5,
  testLink6: config.CONTRACT.TEST_LINK_6,
};

export const wagmiConfig = createConfig({
  chains: [
    sepolia,
    // base,
    bscTestnet,
    mainnet,
    polygon,
    bsc,
    arbitrum,
    avalanche,
    linea,
    opBNB,
  ],
  transports: {
    // [base.id]: http(TEST_LINK.testLink),
    [sepolia.id]: http(),
    [bsc.id]: http(),
    [polygon.id]: http(),
    [arbitrum.id]: http(),
    [avalanche.id]: http(),
    [linea.id]: http(),
    [bscTestnet.id]: http(),
    [opBNB.id]: http(),
    [mainnet.id]: http(),
  },
});

const privyConfig: PrivyClientConfig = {
  embeddedWallets: {
    createOnLogin: "users-without-wallets",
    requireUserPasswordOnCreate: true,
  },
  loginMethods: ["wallet", "email", "sms"],
  appearance: {
    showWalletLoginFirst: true,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: Config.NETWORK_CONFIG.RETRY,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 3,
    },
  },
});

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <PrivyProvider
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      appId={Config.NETWORK_CONFIG.PRIVY_APP_ID as string}
      config={privyConfig}
    >
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={wagmiConfig} reconnectOnMount={false}>
          {children}
        </WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  );
}
